import { useEffect, useState } from "react";
import { GeoJSON } from "react-leaflet";
import { fetchMitecoBasins } from "../model/mitecoLayers.ts";
import { MITECO_BASINS_STYLE } from "./mapStyles.ts";

const ATTRIBUTION = '&copy; <a href="https://www.miteco.gob.es">MITECO</a>';

/**
 * MITECO's official river basins, shown as plain visual context while
 * picking SUB-basins (MitecoSubBasinsLayer.tsx) — so it's clear a
 * sub-basin belongs to, say, the Júcar without switching to "Basins" mode
 * just to check. Non-interactive on purpose (`interactive: false` in the
 * style, a real Leaflet path option, not just CSS): unlike
 * MitecoBasinsLayer.tsx (the actual "add a whole basin" mode, click-to-
 * select), this is only a backdrop — it must never intercept clicks or
 * hover meant for the sub-basins layer underneath.
 */
export function MitecoBasinsOutline() {
  const [data, setData] = useState<GeoJSON.FeatureCollection | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchMitecoBasins().then((fetched) => {
      if (!cancelled) setData(fetched);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!data) return null;
  return (
    <GeoJSON
      data={data}
      style={{ ...MITECO_BASINS_STYLE, interactive: false }}
      attribution={ATTRIBUTION}
    />
  );
}
